import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  UpgradeOfferBenefit,
} from 'Views/FreemiumEntry/HasRelationship/Content/Templates/InsightUpgrade/UpgradeOffer/UpgradeOfferBenefit';
import React from 'react';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import {
  SmallDivider,
} from 'Views/FreemiumEntry/HasRelationship/Content/Templates/InsightUpgrade/UpgradeOffer/SmallDivider';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['benefitSectionTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
    },
  }, overrideReadOnly);

export const OfferBenefitsSection = ({ resource }) => {
  const offerBenefitsCollection = resource.attr('offerBenefits');
  if (offerBenefitsCollection?.resources().empty()) {
    return null;
  }
  return (
    <>
      <SmallDivider />
      <MetaControl attrName={'benefitSectionTitle'} metaOverrideSet={metaOverrides} resource={resource} />
      {offerBenefitsCollection.resources().list().map((item, idx) => (
        <FDStack direction={'column'} spacing={3} key={item.id()}>
          <UpgradeOfferBenefit resource={item} />
          {idx !== offerBenefitsCollection.resources().length() - 1 ? <SmallDivider /> : null}
        </FDStack>
      ))}
    </>
  );
};
